/** biome-ignore-all lint/suspicious/noExplicitAny: TODO: fix */
import { DEFAULT_STORE_OBJECT } from '@/redux/constants';
import type { DefaultStoreObject } from '@/redux/types';
import { generateUUIDv4 } from '@/utils/number';
import type { ProcurementLocation } from '@/views/screens/Procurement';

import ProcurementLocationType from './ProcurementLocationTypes';
import getcreateUpdateProcurementLocationReq from './requestPayload/CreateUpdateLocation';
import postBindLocationList from './requestPayload/PostBindLocationList';

export interface ProcurementLocationState extends Record<string, any> {
  locationList: DefaultStoreObject<ProcurementLocation[]> & {
    totalRecord: number;
  };
  setAddNewLocationData: {
    btnClicked: boolean;
  };
  checkedSelectedLocation: boolean;
}

const initialState: ProcurementLocationState = {
  checkedSelectedLocation: false,
  createUpdateProcurementLocation: {
    ...DEFAULT_STORE_OBJECT,
    data: [],
    req: {
      ...getcreateUpdateProcurementLocationReq,
    },
  },
  locationList: {
    ...DEFAULT_STORE_OBJECT,
    data: [],
    totalRecord: 0,
  },
  locationListReq: {
    ...postBindLocationList,
  },
  setAddNewLocationData: {
    btnClicked: false,
  },
};

// biome-ignore lint/style/useDefaultParameterLast: TODO: fix
const ProcurementLocationReducer = (state = initialState, { type, payload }: any): ProcurementLocationState => {
  switch (type) {
    case ProcurementLocationType.CHECK_SELECTED_LOCATION_VALUE_UPDATE: {
      return {
        ...state,
        checkedSelectedLocation: payload,
      };
    }
    /** Procurement route config location search list reducer start */
    case ProcurementLocationType.GET_PROCUREMENT_LOCATION_LIST: {
      return {
        ...state,
        locationList: {
          ...DEFAULT_STORE_OBJECT,
          ...state.locationList,
          progressing: true,
        },
      };
    }

    case ProcurementLocationType.GET_PROCUREMENT_LOCATION_LIST_SUCCESS: {
      // @ts-expect-error
      payload?.data?.data.forEach((element) => {
        element.renderKey = generateUUIDv4();
        element.isNew = false;
        element.checked = state.checkedSelectedLocation;
      });
      return {
        ...state,
        locationList: {
          ...DEFAULT_STORE_OBJECT,
          ...state.locationList,
          data: [...(state.locationList.data || []), ...payload.data.data],
          progressing: false,
          success: true,
          totalRecord: payload.data.total,
        },
      };
    }

    case ProcurementLocationType.GET_PROCUREMENT_LOCATION_LIST_FAIL: {
      return {
        ...state,
        locationList: {
          ...DEFAULT_STORE_OBJECT,
          ...state.locationList,
          error: true,
          progressing: false,
          totalRecord: 0,
        },
      };
    }

    case ProcurementLocationType.UPDATE_SELECTED_LOCATION: {
      const locationValues = [...(state.locationList.data || [])];

      locationValues.forEach((element) => {
        if (payload?.renderKey && element.renderKey === payload?.renderKey) {
          element.checked = payload?.checked;
          // biome-ignore lint/suspicious/noDoubleEquals: TODO: fix
        } else if (typeof payload.renderKey == 'undefined') {
          element.checked = payload?.checked;
        }
      });
      return {
        ...state,
        checkedSelectedLocation: payload?.checked,
        locationList: {
          ...state.locationList,
          data: locationValues,
        },
      };
    }

    case ProcurementLocationType.RESET_PROCUREMENT_LOCATION_LIST: {
      return {
        ...state,
        locationList: {
          ...state.locationList,
          data: [],
        },
      };
    }

    case ProcurementLocationType.SET_PROCUREMENT_LOCATION_LIST_REQUEST: {
      if (payload === 'reset') {
        return {
          ...state,
          locationList: {
            ...state.locationList,
            data: state.locationList?.data?.[0]?.isNew === true ? [state.locationList.data[0]] : [],
          },
          locationListReq: {
            ...postBindLocationList,
          },
        };
      }
      return {
        ...state,
        locationListReq: {
          ...state.locationListReq,
          ...payload,
        },
      };
    }
    /** Procurement route config location search list reducer end */

    case ProcurementLocationType.SET_ADD_NEW_LOCATION: {
      let stateValue = {
        ...state,
        setAddNewLocationData: {
          btnClicked: payload.btnClicked,
        },
      };
      if (payload?.add === true) {
        stateValue = {
          ...stateValue,
          locationList: {
            ...state.locationList,
            // @ts-expect-error
            data: [{ isNew: true, renderKey: generateUUIDv4() }, ...(state.locationList.data || [])],
          },
        };
      }
      if (payload?.remove === true) {
        const removeItem = state.locationList.data?.slice(1);
        stateValue = {
          ...stateValue,
          locationList: {
            ...state.locationList,
            data: [...(removeItem || [])],
          },
        };
      }
      return stateValue;
    }
    case ProcurementLocationType.CREATE_UPDATE_PROCUREMENT_LOCATION: {
      return {
        ...state,
        createUpdateProcurementLocation: {
          ...state.createUpdateProcurementLocation,
          progressing: true,
        },
      };
    }

    case ProcurementLocationType.CREATE_UPDATE_PROCUREMENT_LOCATION_SUCCESS: {
      return {
        ...state,
        createUpdateProcurementLocation: {
          ...DEFAULT_STORE_OBJECT,
          ...state.createUpdateProcurementLocation,
          data: payload.data,
          error: false,
          progressing: false,
          success: true,
        },
      };
    }

    case ProcurementLocationType.CLEAR_PROCUREMENT_LOCATION_CREATION: {
      return {
        ...state,
        createUpdateProcurementLocation: {
          ...DEFAULT_STORE_OBJECT,
          ...state.createUpdateProcurementLocation,
          error: false,
          success: false,
        },
      };
    }

    case ProcurementLocationType.CREATE_UPDATE_PROCUREMENT_LOCATION_FAIL: {
      return {
        ...state,
        createUpdateProcurementLocation: {
          ...DEFAULT_STORE_OBJECT,
          ...state.createUpdateProcurementLocation,
          data: payload,
          error: true,
          progressing: false,
          success: false,
        },
      };
    }

    default:
      return state;
  }
};

// biome-ignore lint/style/noDefaultExport: TODO: fix
export default ProcurementLocationReducer;
